/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Campagne',
    CERTIFICATES: 'Certificati',
    CHALLENGES: 'Sfide',
    CHAT: 'Chat',
    CLOSE: 'Chiudi',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Prodotti commissionati',
    COMMUNICATIONS: 'Comunicazioni',
    CONFIRM: 'Conferma',
    COUNTERPART: 'Contropartite',
    DASHBOARD: 'Pannello di controllo',
    DESIGN_REQUESTS: 'Richieste di progettazione',
    DETAILS: 'Dettagli',
    EXTERNAL_APPLICATIONS: 'Applicazioni esterne',
    FOLLOWER_MESSAGES: 'Messaggi dei follower',
    GENERICS: 'Generiche',
    LINKS: 'Link',
    LIVE: 'Dirette',
    LOGOUT: 'Logout',
    MEMBERS: 'Membro',
    MENTIONS: 'Menzioni',
    OFFERS: 'Offerte',
    ON_DEMAND_CAMPAIGNS: 'Campagne su richiesta',
    OPPORTUNITIES: 'Opportunità',
    ORDERS: 'Ordini pagati',
    PARTNERS: 'Partner',
    PERSONAL_AREA: 'Area personale',
    PRODUCTS_OFFERED: 'Prodotti offerti',
    PROFILE: 'Profilo',
    PROZIS_COMMUNITY: 'Comunità Prozis',
    QUESTIONS: 'Questioni',
    REMUNERATIONS: 'Retribuzioni',
    SELECT_LANGUAGE: 'Seleziona lingua',
    SELECT_PARTNER: 'Seleziona un altro partner',
    SERVICES: 'Servizi',
    SOCIAL_NETWORK: 'Rete sociale Prozis',
    STATISTICS: 'Statistiche',
    VIDEO_TUTORIALS: 'Video tutorial'
  },
  ERROR: {
    ERROR: 'Errore',
    FETCH_DATA: 'Recupera i dati'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Campagne',
    CHALLENGES: 'Sfide',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Comunicazioni',
    COUNTERPARTS: 'Contropartite',
    DASHBOARD: 'Pannello di controllo',
    DESIGN_REQUESTS: 'Richieste di progettazione',
    DETAILS: 'Dettagli',
    EXTERNAL_APPLICATIONS: 'Applicazioni esterne',
    FILTER: 'Filtra',
    FILTERED: 'Filtrato',
    FOLLOWER_MESSAGES: 'Messaggi dei follower',
    GENERICS: 'Generiche',
    HOME: 'Home',
    LINKS: 'Link',
    LOGOUT: 'Logout',
    MEMBERS: 'Soci',
    MENTIONS: 'Menzioni di Instagram',
    NOT_FOUND: '404, ti sei perso???',
    OFFERS: 'Offerte',
    ORDERS: 'Ordini',
    PARTNERSHIP_NOT_FOUND: 'Nessuna partnership trovata.',
    PENDING_COUNTERPART: 'Contropartite in sospeso di periodi precedenti',
    PENDING_COUNTERPART_CURRENT: 'Contropartite in sospeso di questo mese',
    PENDING_REMUNERATION: 'Retribuzioni in sospeso di periodi precedenti',
    PENDING_REMUNERATION_CURRENT: 'Retribuzioni in sospeso di questo mese',
    PERSONAL_AREA: 'Area personale',
    PRODUCTS: 'Prodotti',
    REMUNERATIONS: 'Retribuzioni',
    SEARCH_PARTNERSHIP: 'Cerca una partnership',
    SELECT_LANGUAGE: 'Selezionare una lingua',
    SELECT_PARTNERSHIP: 'Selezionare una partnership',
    UNAUTHROZIED: '403, Accesso non autorizzato'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
